import { cn } from 'cn';

type P = {
  readonly label: string;
} & ComponentStyling;

/**
 * Placeholder for a file without a preview: a tinted tile with the file type
 * (e.g. `PDF`) as a badge. Size it via `className`.
 */
export function FileTypeSymbol({ className, label, style }: P) {
  return (
    <div
      className={cn(
        'flex items-center justify-center bg-linear-to-br from-tiga-text-lighter/10 to-tiga-text-lighter/25',
        className,
      )}
      style={style}
    >
      <div className="rounded-md border border-tiga-border-default bg-white/80 px-2 py-1.5 text-sm font-semibold tracking-widest text-tiga-text-lighter">
        {label}
      </div>
    </div>
  );
}
